import React from "react";
import {
  gnc,
  configuration,
  house,
  CloudInsights,
  licenseManagement,
  SiraNavIcon,
  BudgetIcon,
} from "../assets/images/index";

const SignIn = React.lazy(() => import("../features/auth/SignIn"));
const Version = React.lazy(() => import("../VersionTable.js"));
const ConfigurationPage = React.lazy(
  () => import("../features/auth/ConfigurationPage"),
);
const LicenseBackend = React.lazy(
  () => import("../features/auth/LicenseBackend"),
);
const HomePage = React.lazy(
  () => import("../features/homePage/HomePageLanding.js"),
);

const BudgetManagement = React.lazy(
  () => import("../features/BudgetModule/BudgetManagement"),
);

const BudgetConfiguration = React.lazy(
  () => import("../features/BudgetModule/Configuration"),
);

const TpaCsd = React.lazy(
  () => import("../features/BudgetModule/Configuration/TpaCsd"),
);

const SubConManagement = React.lazy(
  () => import("../features/BudgetModule/SubConManagement"),
);

const SubConFormPage = React.lazy(
  () => import("../features/BudgetModule/SubConManagement/SubConFormPage"),
);

const InvoiceManagement = React.lazy(
  () => import("../features/BudgetModule/InvoiceManagement"),
);

const BudgetDashboard = React.lazy(
  () => import("../features/BudgetModule/BudgetDashboard"),
);

const PMOApproval = React.lazy(
  () => import("../features/BudgetModule/PMOApproval"),
);

const CloudCostInsights = React.lazy(
  () => import("../features/gnc/CloudCostInsights/Landing.js"),
);

const ContainerCost = React.lazy(
  () => import("../features/gnc/ContainerCost/ContainerCostLanding.js"),
);

const ContainerCostOverview = React.lazy(
  () => import("../features/gnc/ContainerCost/CostOverviewLanding.js"),
);

const MarketPlace = React.lazy(
  () => import("../features/gnc/MarketPlace/MarketPlaceContainer.js"),
);

const MarketPlaceOverview = React.lazy(
  () => import("../features/gnc/MarketPlace/OverviewContainer.js"),
);
const LicenseManagement = React.lazy(
  () => import("../features/gnc/LicenseManagement/LincenseLanding"),
);
const LicenseEntitlement = React.lazy(
  () =>
    import("../features/gnc/LicenseManagement/LicenseEntitleMent/LicenseEntitlement"),
);

const SecurityHubFindings = React.lazy(
  () =>
    import("../features/gnc/complianceCheck/securityHub/securityHubFindingsLandings"),
);
const CloudScape = React.lazy(
  () =>
    import("../features/gnc/complianceCheck/CloudScape/cloudScapeLandings.js"),
);
const CisoSHFLanding = React.lazy(
  () => import("../features/gnc/cisoDashboard/CisoSHFLanding.js"),
);
const CisoCloudScapeLanding = React.lazy(
  () => import("../features/gnc/cisoDashboard/CisoCloudScapeLanding.js"),
);

const CCIBudgetCost = React.lazy(
  () => import("../features/gnc/CloudCostInsights/BudgetCostLanding.js"),
);
const CCIPlatformSummary = React.lazy(
  () =>
    import("../features/gnc/CloudCostInsights/Platform/Summary/PlatFormSummaryLanding.js"),
);
const CCIPlatformOverView = React.lazy(
  () =>
    import("../features/gnc/CloudCostInsights/Platform/Overview/PlatFormOverviewLanding.js"),
);
const CCIPlatformGovTechComparison = React.lazy(
  () =>
    import("../features/gnc/CloudCostInsights/Platform/GovTechComparison/GovTechComparisonLanding.js"),
);
const AppConfig = React.lazy(
  () => import("../features/configuration/cmdb/appConfig/AppConfig.js"),
);

const AppConfigServers = React.lazy(
  () => import("../features/configuration/cmdb/appConfig/Servers"),
);
const LicenseConfigpage = React.lazy(
  () => import("../features/configuration/cmdb/licenseconfig"),
);

const ApplicationConfiguration = React.lazy(
  () => import("../features/configuration/cmdb/CmdbApplicationConfiguration"),
);

const AppConfigAccountId = React.lazy(
  () => import("../features/configuration/cmdb/appConfig/accountIds"),
);

const AuditLog = React.lazy(
  () => import("../features/efficiency/auditLog/AuditLog"),
);

const UserSession = React.lazy(
  () => import("../features/efficiency/userSessionLog/userSessionLog.js"),
);
const Tools = React.lazy(
  () => import("../features/configuration/settings/tools/Tools"),
);

const CloudCostConfig = React.lazy(
  () =>
    import("../features/configuration/settings/CloudCostConfig/GCCCloudCost/CloudCostGCCLandings.jsx"),
);

const Business = React.lazy(
  () =>
    import("../features/configuration/cmdb/BusinessInfo/BusinessInfoLanding.js"),
);

const OrganizationInfo = React.lazy(
  () =>
    import("../features/configuration/cmdb/Organizational-Info/OrganizationalInfo"),
);

const SoftwareInventory = React.lazy(
  () =>
    import("../features/configuration/cmdb/SoftwareInventory/SoftwareInventory.js"),
);

const Devices = React.lazy(
  () => import("../features/configuration/cmdb/MasterDevices/Devices.js"),
);

const SoftwareGroup = React.lazy(
  () => import("../features/configuration/cmdb/SoftwareGroup/SoftwareGroup.js"),
);
const ESXLanding = React.lazy(
  () => import("../features/configuration/cmdb/ESX/ESXLanding.js"),
);
const Cloudaccount = React.lazy(
  () => import("../features/configuration/cmdb/cloudaccounttable/cloudaccount"),
);

const PIIDataConfiguration = React.lazy(
  () =>
    import("../features/configuration/settings/PIIConfiguration/PIIConfigurationContainer"),
);

const Schedulers = React.lazy(
  () =>
    import("../features/configuration/settings/Schedulers/ManageSchedulers.js"),
);
const LdapConfig = React.lazy(
  () => import("../features/configuration/admin/ldapConfig/LdapConfig"),
);
const SmtpConfig = React.lazy(
  () => import("../features/configuration/admin/smtpConfig/SmtpConfig"),
);
const LicenseConfig = React.lazy(
  () => import("../features/configuration/admin/licenseConfig/LicenseConfig"),
);
const UserManagement = React.lazy(
  () => import("../features/configuration/admin/userManagement/UserManagement"),
);
const UserRoleMap = React.lazy(
  () => import("../features/configuration/admin/UserRoleMap/UserRoleTable"),
);
const LoggingConfig = React.lazy(
  () => import("../features/configuration/admin/loggingConfig/LoggingConfig"),
);

const SirarLandings = React.lazy(
  () => import("../features/Sirar/SirarLandings.js"),
);

const SirarCisoLandings = React.lazy(
  () => import("../features/SirarCiso/CisoLandings.js"),
);
const SirarCisoTLLandings = React.lazy(
  () => import("../features/SirarTLReview/CisoLandings.js"),
);

export const authRoutes = [
  {
    name: "SignIn",
    path: "/logout",
    component: <SignIn />,
    key: 0,
  },
  {
    name: "SignIn",
    path: "/auth",
    component: <SignIn />,
    key: 0,
  },
  {
    name: "Version",
    path: "/version",
    component: <Version />,
    key: 0,
  },
  {
    name: "LicenseBackend",
    path: "/LicenseBackend",
    component: <LicenseBackend />,
    key: 0,
  },
  {
    name: "ConfigurationPage",
    path: "/ConfigurationPage",
    component: <ConfigurationPage />,
    key: 0,
  },
];

export const routes = [
  //CODE8 Home page
  {
    name: "Home",
    path: "home",
    component: <HomePage />,
    key: "5",
    icon: house,
    iconNavigation: true,
    childNavs: [
      {
        name: "Home",
        text: "Home",
        path: "home",
        component: <HomePage />,
        key: "5.1",
        navigationDisable: true,
        isNotSideBarNavigation: true,
      },
      {
        name: "Business Info",
        path: "home/BusinessInfoConfig",
        component: <Business />,
        key: "5.3",
        isNotSideBarNavigation: true,
      },
      {
        name: "Server",
        path: "home/:appName/DeviceConfig",
        isNotSideBarNavigation: true,
        key: "5.4",
        component: <AppConfigServers />,
      },
      {
        name: "Account IDs",
        path: "home/:appName/accountIDs",
        isNotSideBarNavigation: true,
        key: "5.5",
        component: <AppConfigAccountId />,
      },
    ],
  },

  //CODE8 Governance and Compliance
  {
    name: "Governance and Compliance",
    path: "gnc",
    component: <LicenseManagement />,
    key: "2",
    icon: gnc,
    //iconNavigation:true,
    toolTipCustomClass: "hovertipgnc",
    childNavs: [
      {
        name: "Compliance",
        text: "Compliance",
        path: "gnc/compliance/CloudScapeFindings",
        component: <CloudScape />,
        navigationDisable: false,
        key: "2.2",
        childNavs: [
          {
            name: "CISO Dashboard",
            text: "CISO Dashboard",
            path: "gnc/CISOInsights/securityHubFindings",
            component: <CisoSHFLanding />,
            key: "2.2.2",
          },
          {
            name: "CISO Dashboard",
            text: "CISO Dashboard",
            path: "gnc/CISOInsights/CloudScapeFindings",
            component: <CisoCloudScapeLanding />,
            key: "2.2.3",
          },

          {
            name: "Security Hub Findings",
            text: "Security Hub Findings",
            path: "gnc/compliance/securityHub/securityHubFindingsLandings",
            component: <SecurityHubFindings />,
            key: "2.2.5",
          },
          {
            name: "CloudScape Findings",
            text: "CloudScape Findings",
            path: "gnc/compliance/CloudScapeFindings",
            component: <CloudScape />,
            key: "2.2.6",
          },
        ],
      },
      {
        name: "Ciso Insights",
        text: "CISO Insights",
        path: "gnc/CISOInsights/CloudScapeFindings",
        component: <CisoCloudScapeLanding />,
        key: "2.3",
      },
    ],
  },

  {
    name: "Cost Insights",
    path: "costInsights",
    component: <CloudCostInsights />,
    key: "3",
    icon: CloudInsights,
    iconClass: "cloudCostWidth",
    iconNavigation: false,
    childNavs: [
      {
        name: "Cloud Cost",
        text: "Cloud Cost",
        path: "costInsights/cloudCost",
        component: <CloudCostInsights />,
        key: "3.1",
        navigationDisable: false,
        isNotSideBarNavigation: false,
      },
      {
        name: "Container Cost",
        text: "Container Cost",
        path: "costInsights/containerCost",
        component: <ContainerCost />,
        key: "3.1",
        navigationDisable: false,
        isNotSideBarNavigation: false,
      },
      {
        name: "Cost Overview",
        text: "Cost Overview",
        path: "costInsights/containerCost/CostOverview",
        component: <ContainerCostOverview />,
        key: "3.2",
        isNotSideBarNavigation: true,
      },

      {
        name: "Marketplace Cost",
        text: "Marketplace Cost",
        path: "costInsights/marketplacecost",
        component: <MarketPlace />,
        key: "3.2",
        navigationDisable: false,
        isNotSideBarNavigation: false,
      },
      {
        name: "Cost Overview",
        text: "Cost Overview",
        path: "costInsights/marketplacecost/CostOverview",
        component: <MarketPlaceOverview />,
        key: "3.1.1",
        isNotSideBarNavigation: true,
      },
      {
        name: "Cost Overview",
        text: "Cost Overview",
        path: "costInsights/cloudCost/CostOverview",
        component: <CCIBudgetCost />,
        key: "3.2",
        isNotSideBarNavigation: true,
      },
      {
        name: "Cost Overview - Platform",
        text: "Cost Overview - Platform",
        path: "costInsights/CostOverviewPlatform/Summary",
        component: <CCIPlatformSummary />,
        key: "3.3",
        navigationDisable: true,
        isNotSideBarNavigation: true,
      },
      {
        name: "Cost Overview - Platform",
        text: "Cost Overview - Platform",
        path: "costInsights/CostOverviewPlatform/Overview",
        component: <CCIPlatformOverView />,
        key: "3.4",
      },
      {
        name: "Cost Overview - Platform",
        text: "Cost Overview - Platform",
        path: "costInsights/CostOverviewPlatform/CostComparison",
        component: <CCIPlatformGovTechComparison />,
        key: "3.5",
        navigationDisable: true,
        isNotSideBarNavigation: true,
      },
    ],
  },
  //License Management
  {
    name: "Software License Management",
    path: "softwareLicenseManagement",
    component: <CloudCostInsights />,
    key: "4",
    icon: licenseManagement,
    iconNavigation: false,
    childNavs: [
      {
        name: "License Management",
        text: "License Management",
        path: "softwareLicenseManagement/Summary",
        // path: "licenseManagement/Summary",
        component: <LicenseManagement />,
        key: "4.1",
        customDropContainerClass: "CMDB",
      },
      {
        name: "Software Group",
        text: "Software Group",
        path: "softwareLicenseManagement/softwareGroup",
        component: <SoftwareGroup />,
        key: "4.3",
      },
      {
        name: "Software List",
        text: "Software List",
        path: "softwareLicenseManagement/SoftwareList",
        component: <SoftwareInventory />,
        key: "4.2",
      },
      {
        name: "License Entitlement",
        text: "License Entitlement",
        path: "softwareLicenseManagement/licenseManagement",
        component: <LicenseEntitlement />,
        key: "2.2.6",
        isNotSideBarNavigation: true,
      },
      {
        name: "gnc",
        text: "License Management",
        isNotSideBarNavigation: true,
        path: "/softwareLicenseManagement/licenseManagement/licenseconfigpage",
        component: <LicenseConfigpage />,
        key: "2.5",
      },
      {
        name: "ESX Group",
        text: "ESX Group",
        path: "softwareLicenseManagement/ESXGroup",
        component: <ESXLanding />,
        key: "4.4",
      },
    ],
  },
  {
    name: "SIRAR",
    path: "Sirar",
    component: <SirarLandings />,
    key: "5",
    icon: SiraNavIcon,
    iconNavigation: true,
    childNavs: [
      {
        name: "SIRAR",
        text: "SIRAR",
        path: "Sirar",
        component: <SirarLandings />,
        key: "5.1",
      },
      {
        name: "Log Reviewer Insights",
        text: "Log Reviewer Insights",
        path: "Sirar/logReviewerInsights",
        component: <SirarCisoTLLandings />,
        key: "5.3",
      },
      {
        name: "Log Approver Insights",
        text: "Log Approver Insights",
        path: "Sirar/logApproverInsights",
        component: <SirarCisoLandings />,
        key: "5.4",
      },
    ],
  },
  {
    name: "Finance and Budget",
    path: "financeAndBudget",
    component: <BudgetDashboard />,
    key: "8",
    icon: BudgetIcon,
    iconNavigation: true,
    childNavs: [
      {
        name: "Overview",
        text: "Overview",
        path: "financeAndBudget/overview",
        component: <BudgetDashboard />,
        key: "8.1",
      },
      {
        name: "Budget Management",
        text: "Budget Management",
        path: "financeAndBudget/budgetManagement",
        component: <BudgetManagement />,
        key: "8.3",
      },
      {
        name: "Supplier Contract Management",
        text: "Supplier Contract Management",
        path: "financeAndBudget/subconManagement",
        component: <SubConManagement />,
        key: "8.4",
      },
      {
        name: "Create SubCon",
        path: "financeAndBudget/subconManagement/createsubcon",
        component: <SubConFormPage />,
        key: "8.4.1",
        isNotSideBarNavigation: true,
      },
      {
        name: "Update SubCon",
        path: "financeAndBudget/subconManagement/updatesubcon",
        component: <SubConFormPage />,
        key: "8.4.2",
        isNotSideBarNavigation: true,
      },
      // {
      //   name: "PMO Approval",
      //   text: "PMO Approval",
      //   path: "financeAndBudget/pmoApproval",
      //   component: <PMOApproval />,
      //   key: "8.7",
      // },
      {
        name: "Invoice Management",
        text: "Invoice Management",
        path: "financeAndBudget/invoiceManagement",
        component: <InvoiceManagement />,
        key: "8.5",
      },
      {
        name: "Configuration",
        text: "Configuration",
        path: "financeAndBudget/config",
        component: <BudgetConfiguration />,
        navigationDisable: true,
        breadcrumbNavDisable: true,
        customDropContainerClass: "budgetConfig",
        key: "8.6",
        childNavs: [
          {
            name: "Project & Catagory",
            text: "Project & Category",
            path: "financeAndBudget/config",
            component: <BudgetConfiguration />,
            key: "8.6.2",
          },
          {
            name: "Others",
            text: "Others",
            path: "financeAndBudget/config/others",
            component: <TpaCsd />,
            key: "8.6.1",
          },
        ],
      },
    ],
  },

  //CODE8 Configuration
  {
    name: "Configuration",
    path: "configuration",
    component: <Tools />,
    key: "5",
    icon: configuration,
    childNavs: [
      {
        name: "CMDB",
        text: "CMDB",
        path: "configuration/cmdb",
        //navigationDisable: true,
        navigationDisableRoles: ["Invoice Team", "PMO", "PM", "Budget Admin"],
        customDropContainerClass: "CMDB",
        component: <AppConfig />,
        key: "5.11",
        childNavs: [
          {
            name: "Business Info",
            text: "Business Info",
            path: "configuration/cmdb/BusinessInfoConfig",
            component: <Business />,
            key: "5.11.1",
          },
          {
            name: "Role Allocation",
            text: "Role Allocation",
            path: "configuration/cmdb/BusinessInfoConfig/roleAllocation",
            component: <OrganizationInfo />,
            key: "5.11.2",
            isNotSideBarNavigation: true,
          },
          {
            name: "Cloud Accounts",
            text: "Cloud Accounts",
            path: "configuration/cmdb/masterlist/cloudaccount",
            component: <Cloudaccount />,
            key: "5.11.4",
          },
          {
            name: "Devices",
            text: "Devices",
            path: "configuration/cmdb/masterlist/Devices",
            component: <Devices />,
            key: "5.11.5",
          },

          {
            name: "AppConfig",
            // text: "App Config",
            path: "configuration/cmdb",
            isNotSideBarNavigation: true,
            component: <AppConfig />,
            key: "5.11.6",
          },
          {
            key: "5.11.10",
            name: "Account IDs",
            path: "configuration/cmdb/:appName/accountIDs",
            isNotSideBarNavigation: true,
            component: <AppConfigAccountId />,
          },
          {
            key: "5.11.11",
            name: "Application Configuration",
            text: "Application Configuration",
            path: "configuration/cmdb/applicationConfiguration",
            isNotSideBarNavigation: true,
            component: <ApplicationConfiguration />,
          },
        ],
      },
      {
        key: "6.0",
        name: "License Config",
        path: "configuration/cmdb/Devices/licenseconfigpage",
        isNotSideBarNavigation: true,
        component: <LicenseConfigpage />,
      },
      {
        name: "Settings",
        text: "Settings",
        path: "configuration/settings/tools",
        navigationDisable: true,
        customDropContainerClass: "settings",
        component: <Tools />,
        key: "5.1",
        childNavs: [
          {
            name: "Cloud Cost",
            text: "Cloud Cost",
            path: "configuration/settings/CloudCost",
            component: <CloudCostConfig />,
            key: "5.1.3",
          },
          {
            name: "Schedulers",
            text: "Schedulers",
            path: "configuration/settings/Schedulers",
            component: <Schedulers />,
            key: "5.1.1",
          },
          {
            name: "Tools",
            text: "Tools",
            path: "configuration/settings/tools",
            component: <Tools />,
            key: "5.1.2",
          },
          {
            name: "PII Data Configuration",
            text: "PII Data Configuration",
            path: "configuration/settings/PIIDataConfiguration",
            isNotSideBarNavigation: true,
            component: <PIIDataConfiguration />,
            key: "5.1.4",
          },
        ],
      },
      {
        name: "Administration",
        text: "Administration",
        path: "configuration/administration/directoryConfiguration",
        navigationDisable: true,
        customDropContainerClass: "admin",
        component: <LdapConfig />,
        key: "5.2",
        childNavs: [
          {
            name: "UserManagement",
            text: "User Management",
            path: "configuration/administration/userManagement",
            component: <UserManagement />,
            key: "5.2.4",
          },
          {
            name: "SmtpConfig",
            text: "SMTP Configuration",
            path: "configuration/administration/smtpConfig",
            component: <SmtpConfig />,
            key: "5.2.2",
          },
          {
            name: "Directory Configuration",
            text: "Directory Configuration",
            path: "configuration/administration/directoryConfiguration",
            component: <LdapConfig />,
            key: "5.2.1",
          },
          {
            name: "LicenseConfig",
            text: "License Configuration",
            path: "configuration/administration/licenseConfig",
            component: <LicenseConfig />,
            key: "5.2.3",
          },
          {
            name: "UserRoleMap",
            text: "Role Mapping",
            isNotSideBarNavigation: true,
            path: "/configuration/administration/userManagement/rolemapping",
            component: <UserRoleMap />,
            key: "5.2.5",
          },
          {
            name: "LoggingConfig",
            text: "Logging Configuration",
            path: "configuration/administration/loggingConfig",
            component: <LoggingConfig />,
            key: "5.2.5",
          },
        ],
      },
      {
        name: "UserSession",
        text: "User Session",
        path: "configuration/usersession",
        component: <UserSession />,
        key: "4.2.6",
      },
      {
        name: "AuditLog",
        text: "Audit Log",
        path: "configuration/auditLog",
        component: <AuditLog />,
        key: "4.2.6",
      },
    ],
  },
];
